import '../App.css';
import React from 'react';
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import awsexports from '../aws-exports';
import { ThemeProvider } from '@aws-amplify/ui-react';
import FaceLivenessCustom from '../Components/FaceLivenessCustom';
import ReferenceImage from '../Components/ReferenceImage';
import {
  View,
  Flex,
} from '@aws-amplify/ui-react';

Amplify.configure(awsexports);


export function LivenessCustom() {

  const [faceLivenessAnalysis, setFaceLivenessAnalysis] = React.useState(null)

  const getFaceLivenessAnalysis = (faceLivenessAnalysis) => {
    if (faceLivenessAnalysis !== null) {
      setFaceLivenessAnalysis(faceLivenessAnalysis)
    }
  }

  const tryAgain = () =>{
    setFaceLivenessAnalysis(null)
  }

  return (
    <ThemeProvider>
    <Flex
      direction="row"
      justifyContent="center"
      alignItems="center"
      alignContent="flex-start"
      wrap="nowrap"
      gap="1rem"
    >
      <View
        as="div"
        maxHeight="600px"
        height="600px"
        width="740px"
        maxWidth="740px"
      >
        {faceLivenessAnalysis && faceLivenessAnalysis.Confidence ? (
          <ReferenceImage faceLivenessAnalysis={faceLivenessAnalysis} tryAgain={tryAgain}></ReferenceImage>
        ) :
          (<FaceLivenessCustom faceLivenessAnalysis={getFaceLivenessAnalysis} tryAgain={tryAgain} />)}

      </View>
    </Flex>
  </ThemeProvider>
);
}

export default LivenessCustom;
